import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StrawStageContent } from '../common/model/dto/straw-stage-content';
import { updateStrawStageContentById } from '../services/admin/admin-straw-stage-content.service';

export function useAdminStrawStageContentMutations(
  strawStageContentId: string
) {
  const qc = useQueryClient();
  const invalidateStrawStageContent = () =>
    qc.invalidateQueries({
      queryKey: ['straw-stage-content', strawStageContentId],
    });

  const updateStrawStageContent = useMutation({
    mutationFn: (updates: Partial<StrawStageContent>) =>
      updateStrawStageContentById(strawStageContentId, updates),
    onSuccess: invalidateStrawStageContent,
  });

  return {
    updateStrawStageContent,
  };
}
